<div class="content dark">
	<div class="row">
		<div class="col-lg-6">
			<div *ngIf="treenodes" class="tree-box">
				<tree-root class="asset-tree" [nodes]="treenodes" (activate)="ActivateNode($event.node)"></tree-root>
			</div>
			<div *ngIf="!treenodes">Loading...</div>
		</div>
		<div class="col-lg-6">
			<div *ngIf="selectedItem">
				<h3 class="node-header">{{selectedItem.name}}</h3>
				<div class="form-group row">
					<label class="col-md-4">Engine:</label>
					<div class="col-md-8">{{selectedItem.engine}}</div>
				</div>
				<div class="form-group row">
					<label class="col-md-4">Gearbox:</label>
					<div class="col-md-8">{{selectedItem.gearbox}}</div>
				</div>
				<div class="form-group row">
					<label class="col-md-4">Assets using this configuration:</label>
					<div class="col-md-8">
						<div *ngFor="let asset of selectedItem.assets">{{asset.asset_name}} ({{asset.obcu_serial_number}})</div>
					</div>
				</div>
				<app-action-button *ngIf="!selectedItem.assets.length" [action]="DeleteConfig" [context]="this" processing="Deleting..."
				 complete="Config deleted" confirm="Are you sure?" btnClass="btn-danger">Delete Config</app-action-button>
				<button *ngIf="selectedItem.assets.length" disabled class="btn btn-danger">Can't delete - existing assets</button>
			</div>
		</div>
	</div>
	<div *ngIf="selectedItem" class="row">
		<div class="col-lg-6">
			<div class="item-panel">
				<div class="heading">Current config XML <button (click)="DuplicateConfig()" class="btn btn-info btn-sm ml-5">Duplicate</button></div>
				<div class="content">
					<div>
						<textarea [(ngModel)]="oldConfig" style="width: 100%;height: 400px;" readonly></textarea>
					</div>
				</div>
			</div>
		</div>
		<div class="col-lg-6">
			<div class="item-panel">
				<div class="heading">New config XML</div>
				<div class="content">
					<div>
						<textarea [(ngModel)]="newConfig" style="width: 100%;height: 400px;"></textarea>
					</div>
				</div>
			</div>
			<app-action-button [action]="UpdateConfig" [context]="this" processing="Updating..." complete="Config updated"
			 btnClass="btn-success">Update Config</app-action-button>
		</div>
	</div>
</div>